var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"other"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.floorShowName))]),_c('ul',_vm._l((_vm.moduleDataSource),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"JavaScript:;"},on:{"click":function($event){return _vm.toDetail(item)}}},[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }